/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/promotion.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopCallRegister from './_PopCallRegister';
import PopNomemberSmsSendingOrder from './_PopNomemberSmsSendingOrder';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
const CallStatus = () => {
  const [modalCallRegister, setModalCallRegister] = useState(false);
  const [modalSmsSendingOrder, setModalSmsSendingOrder] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '비회원 전화수신', value: 0},
    {title: '전화 수신', value: 1},
    {title: '내 확인 전화', value: 2, type: 'red'}
  ];
  return (
    <main className="com_container p_call_status">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_4">전화수신 현황</h2>
          <div className="com_btn_wrap">
            <button
              onClick={() => {
                setModalSmsSendingOrder(true);
              }}
              className="com_btn gray s "
            >
              비회원문의 문자 전송 순서
            </button>
            <button
              onClick={() => {
                setModalCallRegister(true);
              }}
              className="com_btn orange s btn_plus"
            >
              전화수신 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>
            <div className="table_container">
              {/*<span className="com_btn orange s btn_call">010-1234-1344 님의 전화가 왔습니다.</span>*/}
              <table className="com_board_list">
                <colgroup>
                  <col width="10%" />
                  <col width="15%" />
                  <col width="10%" />
                  <col width="10%" />
                  <col width="30%" />
                  <col width="15%" />
                  <col width="10%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>수신일</th>
                    <th>발신번호</th>
                    <th>발신자</th>
                    <th>비고</th>
                    <th>내용</th>
                    <th>수신자</th>
                    <th>확인자</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="td_date">2022, 08, 25</td>
                    <td>010-1234-1324</td>
                    <td>
                      김학생103
                      <br />
                      (부폰)
                    </td>
                    <td>협력업체</td>
                    <td>학생이 산만하다고 합니다.</td>
                    <td>
                      <button className="btn_link">김등록 103</button>
                    </td>
                    <td>
                      <button className="btn_link blue">홍길동103</button>
                    </td>
                  </tr>
                  <tr>
                    <td className="td_date">2022, 08, 25</td>
                    <td>010-1234-1324</td>
                    <td className="td_red">비회원</td>
                    <td className="td_point">비회원 전화</td>
                    <td>학생이 산만하다고 합니다.</td>
                    <td>
                      <button className="btn_link">김등록 103</button>
                    </td>
                    <td>
                      <button className="btn_link red">
                        홍길동103
                        <br />
                        통화완료
                      </button>
                    </td>
                  </tr>
                  <tr className="selected">
                    <td className="td_date">2022, 08, 25</td>
                    <td>010-1234-1324</td>
                    <td>
                      김학생103
                      <br />
                      (부폰)
                    </td>
                    <td>협력업체</td>
                    <td>학생이 산만하다고 합니다.</td>
                    <td>
                      <button className="btn_link">김등록 103</button>
                    </td>
                    <td className="btn_link td_point">홍길동103</td>
                  </tr>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td className="td_date">2022, 08, 25</td>
                        <td>010-1234-1324</td>
                        <td>
                          김학생103
                          <br />
                          (부폰)
                        </td>
                        <td>협력업체</td>
                        <td>학생이 산만하다고 합니다.</td>
                        <td>
                          <button className="btn_link">김등록 103</button>
                        </td>
                        <td>
                          <button className="btn_link blue">홍길동103</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">전화수신 상세내용</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <button className="btn_edit"></button>
            </div>

            <div className="com_board_box">
              <div className="board_subject">
                <BtnLike/>
                <div className="name">비회원 전화</div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">수신일시</span>
                  <span className="cont">2023, 05, 23 15 : 30</span>
                </div>
                <div className="info">
                  <span className="tit">수신번호</span>
                  <span className="cont">010-1234-134</span>
                </div>
                <div className="info">
                  <span className="tit">발신자 명</span>
                  <span className="cont">김아무개</span>
                </div>
              </div>
              <div className="radio_wrap">
                <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                <label htmlFor="rdo_01">비회원 문의</label>
                <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                <label htmlFor="rdo_02">홍보성 전화</label>
                <input type="radio" name="rdo" id="rdo_03" className="com_chk circle" />
                <label htmlFor="rdo_03">잘못걸린 전화</label>
                <input type="radio" name="rdo" id="rdo_04" className="com_chk circle" />
                <label htmlFor="rdo_04">출판관련</label>
                <input type="radio" name="rdo" id="rdo_05" className="com_chk circle" />
                <label htmlFor="rdo_05">협력업체</label>
                <input type="radio" name="rdo" id="rdo_06" className="com_chk circle" />
                <label htmlFor="rdo_06">회원문의</label>
                <input type="radio" name="rdo" id="rdo_07" className="com_chk circle" />
                <label htmlFor="rdo_07">직원문의</label>
                <input type="radio" name="rdo" id="rdo_08" className="com_chk circle" />
                <label htmlFor="rdo_08">교사문의</label>
                <input type="radio" name="rdo" id="rdo_09" className="com_chk circle" />
                <label htmlFor="rdo_09">관공서</label>
                <input type="radio" name="rdo" id="rdo_10" className="com_chk circle" />
                <label htmlFor="rdo_10">부산지사</label>
                <input type="radio" name="rdo" id="rdo_11" className="com_chk circle" />
                <label htmlFor="rdo_11">기타</label>
              </div>
              <div className="input_box">
                <textarea className="textarea" placeholder="메모 입력"></textarea>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_box">※ 아래 수신자에게 5분 간격으로 문자가 발송 됩니다.</div>
            <div className="com_board_box">
              <table className="com_board_list">
                <colgroup>
                  <col width="10%" />
                  <col width="45%" />
                  <col width="45%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>순서</th>
                    <th>수신자</th>
                    <th>전화번호</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(5)].map((_, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>
                        <span className="btn_link">박효숙101</span>
                      </td>
                      <td>010-1234-1314</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임105</button>
                    <span className="date dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <div className="cont">
                    <div className="info">네 확인하여 통화 완료 하였습니다.</div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_comment_wrap">
              <div className="com_input_wrap flex_row">
                <select className="select xs">
                  <option value="통화 완료">통화 완료</option>
                </select>
                <div className="com_btn black xs btn_plus_orange">시범강의 요청</div>
              </div>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="통화 내용 입력" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopCallRegister open={modalCallRegister} close={() => setModalCallRegister(false)} />
      <PopNomemberSmsSendingOrder open={modalSmsSendingOrder} close={() => setModalSmsSendingOrder(false)} />
    </main>
  );
};

export default CallStatus;
